//  in the live hunt version of this puzzle, the client source code was obfuscated 
//    and the border detector was hidden server side.

//  in this static version, all code is client side and in plain view -
//    if you are trying to solve this puzzle, please try without looking in the source!


import * as d3 from 'd3'
import { uiDetectShape, uiInitialize, uiNewLevel, uiWin } from '@/assets/draw/ui.js'
import { classify } from '@/assets/draw/shape.js'

export function draw() {
  var DEFAULT_WIDTH = 940
    , MOBILE_BREAKPOINT = 600
    , DRAWING_SIZE = 256
    , DRAWING_MARGIN = 50
    , DRAWING_TOTAL = DRAWING_SIZE + DRAWING_MARGIN
    , CV_TOLERANCE = .25
    , line = d3.line().curve(d3.curveBasis)
    , margin = {
      top: 20,
      right: 20,
      bottom: 20,
      left: 20
    }
    , d3Draw = d3.select("#draw")
    , containerWidth = d3Draw.node().getBoundingClientRect().width
    , graphicWidth = Math.min(960, containerWidth)
    , width = graphicWidth
    , height = 400
    , header = d3Draw.select(".svg-wrapper")
      .style("max-width", "960px")
      .append("svg")
      .attr("class", "header")
      .attr("width", "100%")
      // .attr("height", "150")
      .attr("viewBox", "0 0 960 150")
    // .attr("preserveAspectRatio", "none")
    , svg = d3Draw.select(".svg-wrapper")
      .append("svg")
      .attr("class", "main")
      .attr("width", "100%")
      // .attr("height", "400")
      .attr("viewBox", "0 0 960 400")
    // .attr("preserveAspectRatio", "none")
    , svg_drawing = svg.append("g").attr("id", "drawing")
    , drawns = svg.append("g").attr("id", "drawns")
    , drawboard = svg.append("rect") // the bounding box for drawing shapes
      .attr("id", "drawboard")
      .attr("width", "400")
      .attr("height", "400")
      // .attr("viewbox", "0 0 400 400")
      .attr("fill", "none")
      // .attr("stroke", "black")
      .attr("pointer-events", "all")
  const token = {}; // token for cancellation

  var shapeLevels = [{ shapeDraw: "circle", shapeDetect: "circle" },
  { shapeDraw: "triangle", shapeDetect: "circle" },
  { shapeDraw: "circle", shapeDetect: "circle" },
  { shapeDraw: "triangle", shapeDetect: "triangle" },
  { shapeDraw: "square", shapeDetect: "circle" },
  { shapeDraw: "square", shapeDetect: "triangle" },
  { shapeDraw: "square", shapeDetect: "square" },
  { shapeDraw: "circle", shapeDetect: "triangle" },
  { shapeDraw: "triangle", shapeDetect: "square" },
  { shapeDraw: "circle", shapeDetect: "square" }
  ];

  var level = 0;
  var shapeLevel = shapeLevels[level];

  var drawPoints = [[], []] // stroke with [x points], [y points]
    , drawing = []; // list of strokes
  var drawings = [];

  uiInitialize(svg, drawboard, header);
  uiNewLevel(shapeLevel.shapeDraw, shapeLevel.shapeDetect, level);


  let svgWidth = 960; // hard coded to allow resizing viewbox
  let svgHeight = 400; 
  let path;

  let restartBox = header.append("rect")
    .attr("class", "restart")
    .attr("x", svgWidth - 70)
    .attr("y", 35)
    .attr("width", 70)
    .attr("height", 35)
    .attr("opacity", 0)
    .on("click", () => {
      level = 0;
      shapeLevel = shapeLevels[0];
      uiNewLevel(shapeLevel.shapeDraw, shapeLevel.shapeDetect, level);
      drawPoints = [[], []];
      drawing = [];
      drawings = [];
      svg_drawing.selectAll("path").remove();
      drawns.selectAll("#drawn")
        .transition()
        .duration(300)
        .attr("opacity", 0)
        .on("end", (_, i, nodes) => {
          nodes[i].remove();
        });
    });

  let restartText = header.insert("text", ".restart")
    .attr("class", "restart noselect")
    .attr("x", svgWidth - 65)
    .attr("y", 60)
    .text("restart");

  // prevent scroll on mobile
  svg.on("touchstart", ()=>{
    d3.event.stopPropagation();
    d3.event.preventDefault();
  });


  drawboard.call(d3.drag().container(function () {
    return this
  }).subject(function () {
    var t = [d3.event.x, d3.event.y];
    return [t, t]
  }).on("start", dragstarted).on("end", dragend));





  // -------- end of init()


  function resetSettings() {
    // disable restart if not already
    if (d3.select(".restart.disable").empty()) {
      header.append("rect")
        .attr("class", "restart disable")
        .attr("x", svgWidth - 70)
        .attr("y", 35)
        .attr("width", 70)
        .attr("height", 35)
        .attr("opacity", 0)
        .transition()
        .duration(300)
        .attr("opacity", 0.7);
    }

    // add new path to svg
    path = svg_drawing.append("path");

    // reset opacity of paths to 1
    svg_drawing.selectAll("path")
      .interrupt() // cancel the current transition (if it's fading out), default 250ms
      .transition() // fade it back in
      .attr("opacity", 1)
      .attr("stroke", "#969696");

    // cancel the async timer submit if it's running
    if (typeof token.cancel === "function") {
      token.cancel();
    }

    drawPoints = [[], []],
      path.attr("class", null);
  }
  function dragstarted() {
    resetSettings();
    var t = d3.event.subject
      , e = path.datum(t) // add a new path instead of only having one
      , n = d3.event.x
      , i = d3.event.y;
    drawPoints[0].push(n),
      drawPoints[1].push(i),
      d3.event.on("drag", function () {

        let mouse = d3.mouse(drawboard.node());
        let x = mouse[0];
        let y = mouse[1];

        let d = x - n
          , c = y - i;

        let bbox = drawboard.node().getBBox();

        // constrain drawing to the drawboard rect.
        if (x < 0) {
          x = 0;
        } else if (bbox.width < x) {
          x = bbox.width;
        }

        if (y < 0) {
          y = 0;
        } else if (bbox.height < y) {
          y = bbox.height;
        }

        drawPoints[0].push(x),
          drawPoints[1].push(y),
          d * d + c * c > 100 ? t.push([n = x, i = y]) : t[t.length - 1] = [x, y],
          e.attr("d", line);
      })
  }

  function zip(drawPoints) {
    points = [];

    for (i = 0; i < drawPoints[0].length; i++) {
      points.push({
        x: drawPoints[0][i],
        y: drawPoints[1][i]
      });
    }

    return points;
  }

  function dragend() {

    // console.log(drawPoints);
    // console.log(path.node());

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    async function clientWinCheck(drawings) {
      const promises = drawings.map(async d => ((await clientDetect(d)).toLowerCase()));
      const response = await Promise.all(promises);
      return response;
    }

    async function clientDetect(drawing) {

      if (drawing.length > 1) return "SQUARE";

      const t = drawing[0];

      var e = t[0].length;
      return (t[0].reduce(function (n, i, r) {
        var a = (r + 1) % e
          , d = i
          , c = t[0][a]
          , s = t[1][r];
        return n + (c - d) * (t[1][a] + s)
      }, 0) < 0) ? "TRIANGLE" : "CIRCLE";
    }

    // submit function, calls detector.php on server 
    async function submit(token, delayms) {
      let cancelled = false;

      token.cancel = () => {
        cancelled = true;
      }

      // console.log(">>>submit after 2 seconds");
      const sleep = await wrapWithCancel(delay)(delayms);

      if (cancelled) {
        throw { reason: 'cancelled' };
      }

      // this only executes if we didn't cancel
      // console.log(">>>dummy submitted!");
      const responseText = await clientDetect(drawing);
      // console.log(responseText); 

      // check if shape is good
      // if good, play good animation and save. advance to next level.
      let shape = responseText.toLowerCase();

      let drawn = svg_drawing.clone(true)
        .attr("id", "drawn")
        .attr("opacity", 1);


      if (shape == shapeLevel.shapeDetect) { // if good
        drawings.push(drawing); // add drawing to progress
      }

      // clear the drawing
      drawing = [];
      svg_drawing.selectAll("path").remove();

      // border animation
      await uiDetectShape(shape, shapeLevel.shapeDetect, shapeLevel.shapeDraw, drawn, svg); // play animation
      // console.log("border animation finished");


      // if good, advance
      if (shape == shapeLevel.shapeDetect) {
        drawns.append(() => drawn.node());

        // advance to next level
        level = level + 1;

        if (level == shapeLevels.length) { // we beat all the levels
          // verify the win through entire payload
          // console.log(drawings);
          const responseText = await clientWinCheck(drawings);
          // console.log(responseText);
          let serverCheck = JSON.stringify(responseText);
          let clientCheck = JSON.stringify(shapeLevels.map(x => x.shapeDetect));

          // console.log(clientCheck, serverCheck, clientCheck == serverCheck);
          if (serverCheck == clientCheck) {


            // confirmed win!              
            let path = "M365,181c0,0-50,0-80,0c-6,0-11-3-15-6l-50-53h220v-16H157l50-53c4-3,10-6,15-6c23,0,88,0,93,0V31h-92 \
        c-11,0-23,6-30,13l0,0l-53,56c-4,3-10,6-15,6H96c-4-19-21-34-41-34c-23,0-42,19-42,42s19,42,42,42c20,0,37-14,41-34h28l0,0h63 \
        c6,0,11,3,15,6l53,56l0,0c7,7,19,13,30,13h80";
            uiWin(svg, path);


          } else {
            console.log("did you cheat to get here?")
          }
          return;
        }


      } else { // wrong border detect
        // go back a level to prevent brute force
        if (level > 0) {
          level -= 1;

          // remove last drawings
          drawings.pop();

          // remove last drawn
          let lastDrawn = drawns.selectAll("#drawn").nodes();
          lastDrawn = d3.select(lastDrawn[lastDrawn.length - 1]);

          lastDrawn.transition()
            .attr("opacity", 0)
            .duration(250)
            .on("end", (_, i, nodes) => {
              nodes[i].remove();
            });

        }

      }


      shapeLevel = shapeLevels[level];

      uiNewLevel(shapeLevel.shapeDraw, shapeLevel.shapeDetect, level);


      // re-enable restart
      d3.selectAll(".restart.disable")
        .transition()
        .duration(200)
        .attr("opacity", 0)
        .on("end", (_, i, nodes) => {
          nodes[i].remove();
        });
      // from https://blog.bloomca.me/2017/12/04/how-to-cancel-your-promise.html
      function wrapWithCancel(fn) {
        return data => {
          if (!cancelled) {
            return fn(data);
          }
        }
      }

    }

    // fadeout the drawing
    async function fade(token, delayms) {
      let cancelled = false;

      token.cancel = () => {
        cancelled = true;
      }

      // console.log(">>>fade after 2 seconds");
      const sleep = await wrapWithCancel(delay)(delayms);

      if (cancelled) {
        throw { reason: 'fade cancelled' };
      }

      // after a successful submit, clear the drawing.
      drawing = [];
      svg_drawing.selectAll("path").remove();

      // re-enable restart
      d3.selectAll(".restart.disable")
        .transition()
        .duration(200)
        .attr("opacity", 0)
        .on("end", (_, i, nodes) => {
          nodes[i].remove();
        });

      // from https://blog.bloomca.me/2017/12/04/how-to-cancel-your-promise.html
      function wrapWithCancel(fn) {
        return data => {
          if (!cancelled) {
            return fn(data);
          }
        }
      }

    }

    drawing.push(drawPoints) // push stroke to list of strokes
    // console.log("drawing", drawing)

    let classes = classify(drawing);
    // console.log(classes);

    function argMax(array) {
      return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
    }

    let shapes = ["triangle", "circle", "square", "squiggle"]
    let shape = shapes[argMax(classes)];
    // console.log(shape);



    if (shape == shapeLevel.shapeDraw) { // passed client side. move to border

      svg_drawing.selectAll("path")
        .transition()
        .duration(0)
        .attr("stroke", "#969696")
        .transition()
        .duration(2000)
        .attr("stroke", "#6ce");

      // starts async timer that will submit drawing to the border shape detector in 1s
      const submitPromise = submit(token, 2000);
      submitPromise.catch(err => {
        // console.log(err); 
      })

    } else {
      svg_drawing.selectAll("path")
        .transition()
        .duration(0)
        .attr("opacity", 1)
        .transition() // we add 500ms so that it gets submitted before it fully fades out, so you can't cancel it just before you can't see it
        .duration(1200)
        .attr("opacity", 0);

      const fadePromise = fade(token, 1000);
      fadePromise.catch(err => {
        // console.log(err);
      })

    }

  }

}


